import * as React from 'react';
import { getContentColor } from '../shared/ProductColors';
import { ContentType } from '../../models';
import { isCurrentMonth } from '../shared/MonthUtils';
import { getAllProducts, getAllInterventions } from '../shared/ProductColors';
import styles from './PlanningGrid.module.scss';

export interface IPlanningCellProps {
  contenu: string;
  mois: string;
  onUpdate: (contenu: string, typeContenu: ContentType) => void;
}

function detectType(value: string): ContentType {
  if (!value) return 'Produit';
  if (value.includes('/')) {
    const parts = value.split('/');
    const interventions = ['VND', 'OD', 'TVX'];
    if (parts.some(p => interventions.includes(p.trim().toUpperCase()))) {
      return 'Transition';
    }
  }
  const upper = value.toUpperCase().trim();
  const interventionList = ['VND', 'OD', 'TVX', 'EPREUVE', 'FOD'];
  if (interventionList.includes(upper) || upper.includes('réaf') || upper.includes('répa')) {
    return 'Intervention';
  }
  return 'Produit';
}

export const PlanningCell: React.FC<IPlanningCellProps> = ({ contenu, mois, onUpdate }) => {
  const [editing, setEditing] = React.useState(false);
  const [value, setValue] = React.useState(contenu);
  const inputRef = React.useRef<HTMLSelectElement>(null);

  const color = getContentColor(contenu);
  const isCurrent = isCurrentMonth(mois);

  const options = [...getAllProducts(), '---', ...getAllInterventions(), '---', 'VND/OD', 'VND/TVX', ''];

  React.useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editing]);

  const handleSave = (newValue: string): void => {
    setEditing(false);
    if (newValue !== contenu) {
      onUpdate(newValue, detectType(newValue));
    }
  };

  if (editing) {
    return (
      <td className={`${styles.monthCell} ${isCurrent ? styles.currentMonth : ''}`}>
        <select
          ref={inputRef}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            handleSave(e.target.value);
          }}
          onBlur={() => handleSave(value)}
          style={{ width: '100%', fontSize: '11px', padding: '2px', border: 'none' }}
        >
          {options.map((opt, i) =>
            opt === '---'
              ? <option key={`sep-${i}`} disabled>{'────────'}</option>
              : <option key={opt} value={opt}>{opt || '(vide)'}</option>
          )}
        </select>
      </td>
    );
  }

  const cellStyle: React.CSSProperties = contenu ? {
    backgroundColor: color.background,
    color: color.text,
  } : {};

  return (
    <td
      className={`${styles.monthCell} ${isCurrent ? styles.currentMonth : ''}`}
      style={cellStyle}
      onClick={() => setEditing(true)}
      title={contenu || 'Cliquer pour éditer'}
    >
      <span style={{ fontWeight: 600, fontSize: '11px' }}>
        {contenu || '\u00A0'}
      </span>
    </td>
  );
};
